import { Component, Input, OnInit } from '@angular/core'
import { LikeService } from 'src/app/service/data/like.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'

@Component({
  selector: 'ddc-like',
  templateUrl: './ddc-like.component.html',
  styleUrl: './ddc-like.component.scss',
})
export class DdcLikeComponent implements OnInit {
  @Input('is_liked') _isLiked: boolean
  @Input('show_count') _showCount: boolean = true
  @Input('content_type_id') _content_type_id: number
  @Input('obj_id') _obj_id: number
  @Input('count') _count: number

  constructor(
    private logger: DdcLoggerService,
    private like_service: LikeService,
  ) {}

  ngOnInit(): void {}

  toggleLike(): void {
    this.logger.info('DdcLikeComponent toggleLike()')

    this._isLiked = !this._isLiked
    this.like_service
      .like(this._isLiked, this._content_type_id, this._obj_id)
      .subscribe((res: any) => {
        if (res.detail == 'liked') {
          this._count++
        } else if (res.detail == 'disliked') this._count--
      })
  }
}
